
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm, pxToEmWithBaseline} from '@insticator/insticator-ui'; // iui-utils
import { buttonStyles } from 'utils/themeV2';


/* ++++++++++ --------------- EXPORT REDIRECT TO PUBLISHER PORTAL v2 BUTTON : STYLES --------------- ++++++++++ */
export default theme => ({
    redirecttoversiontwo: {
        width: pxToEmWithBaseline({ value: 196 , fontSizeBaseline: 14 }),
        height: pxToEmWithBaseline({ value: 32 , fontSizeBaseline: 14 }),
        marginRight: pxToEmWithBaseline({ value: 44 , fontSizeBaseline: 14 }),
        fontSize: pxToEmWithBaseline({ value: 14 , fontSizeBaseline: 15 }),
        fontWeight: 500,
        ...buttonStyles
    }
});
